/* global $ */

import { Controller } from 'stimulus';

function uniqueify(array) {
  return Array.from(new Set(array));
}

export default class extends Controller {
  connect() {
    this.addAction('mouseover', 'stop');
    this.addAction('mouseout', 'start');
    this.start();
  }

  stop() {
    $(this.element).stop(true, true);
    $(this.element).show();
  }

  start() {
    $(this.element)
      .delay(this.delayTime)
      .slideUp(this.duration)
  }

  get duration() {
    return Number(this.data.get('speed')) || 1000;
  }

  get delayTime() {
    return Number(this.data.get('timeout')) || 15000;
  }

  setupActions() {
    this.addAction('mouse', 'start');
  }

  get actions() {
    if (!this.element.dataset.action) return [];
    return this.element.dataset.action.split(' ');
  }

  set actions(value) {
    this.element.dataset.action = uniqueify(value).join(' ');
  }

  addAction(action, method) {
    const actionText = `${action}->${this.identifier}#${method}`;
    this.actions = this.actions.concat([actionText]);
  }
}
